import { NgModule, ApplicationRef, APP_INITIALIZER, Injector, Provider, FactoryProvider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing'
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType, AppHttp, Codes } from './app.service';
import { KeycloakService } from './keycloak.service';

// Core providers
import { CoreModule } from './core/core.module';
import { SmartadminLayoutModule } from './shared/layout/layout.module';
import { UserMangerEditModule } from 'app/pf.main/usermanger/usermangeredit/usermangeredit.module';

export function codeInitFactory(inj: Injector) {
  return () => {
    return inj.get(AppHttp)
      .post('node', '/main/code/codeList', { value: '' })
      .then(o => Codes.setAllCodes(o));
  }
}

// Application wide providers
const APP_PROVIDERS: any[] = [
  ...APP_RESOLVER_PROVIDERS,
  AppState,
  AppHttp,
  Codes,
  KeycloakService,
  {
    provide: APP_INITIALIZER,
    useFactory: codeInitFactory,
    multi: true,
    deps: [Injector]
  }
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    UserMangerEditModule,
    CoreModule,
    SmartadminLayoutModule,

    routing
  ],
  exports: [
  ],
  providers: APP_PROVIDERS
})
export class AppModule {
  constructor(public appRef: ApplicationRef, public appState: AppState) { }


}




// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/app.module.ts